import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import explorosLogo from '../../../../assets/resources/exploros_logo.svg';
import { signupResultLayoutStyles } from './SignupResultLayout.styles';

interface SignupResultLayoutProps {
  title: string;
  children: ReactNode;
}

export function SignupResultLayout({title, children}: SignupResultLayoutProps) {
  const theme = useTheme();

  return (
    <Box component="main" sx={signupResultLayoutStyles.page(theme)}>
      <Box sx={signupResultLayoutStyles.content(theme)}>
        <Box component="header" sx={signupResultLayoutStyles.logoHeader()}>
          <Box component="img" src={explorosLogo} alt="Exploros" sx={signupResultLayoutStyles.logo()} />
        </Box>
        <Box component="section" sx={signupResultLayoutStyles.resultPanel(theme)}>
          <Typography component="h1" sx={signupResultLayoutStyles.title()}>{title}</Typography>
          {children}
        </Box>
      </Box>
    </Box>
  );
}
